import React from 'react';
import { Outlet } from 'react-router-dom';

const IndexCompetitions = () => {

    return <Outlet/>

}

export default IndexCompetitions